export const initialState = () => ({
  currentStep: 0,
  loading: {
    show: false,
    message: ""
  },

  steps: ["Informações", "Pedido", "Biometria", "Segurança"],
  stepsNamesRoutes: [
    "",
    "provider-information",
    "provider-order",
    "provider-biometry",
    "provider-security"
  ],

  segmentOptions: [],

  information: {
    companyName: "",
    contactEmail: "",
    website: "",
    segment: "",
    mainColor: "#000000",
    secondaryColor: "#000000",
    uploads: {
      coloredLogo: [],
      whiteLogo: []
    }
  },

  orderConfig: {
    maximumTvProducts: null,
    maximumFixedProducts: null,
    maximumMobileProducts: null,
    maximumServiceAdditionalProducts: null,
    maximumCartProducts: null,
    days: null,
    workDay: null,
    blockDuplicatedContacts: null
  },

  biometryConfig: {
    geolocationRequired: null,
    maximumTries: null,
    maximumProofOfLifeAttempts: null,
    maximumImageTries: null,
    minimumSimilarity: null,
    minimumCpfSimilarity: null,
    minimumNameSimilarity: null,
    minimumBirthdateSimilarity: null,
    minimumCpfSimilarityEnable: null,
    minimumNameSimilarityEnable: null,
    minimumBirthdateSimilarityEnable: null,
  },

  securityConfig: {
    maximumUserDowntime: null,
    maximumTries: null,
    expirationTime: null,
    mfaEnable: null,
    numberOfPasswordsToCheck: null,
    afterDaysToRequestPasswordChange: null,
    changePasswordAfterDays: null,
    passwordChangeRequired: null,
    geolocationRequired: null
  }
})
